import moment from 'moment';
import request from '../../../util/SuperagentUtils';
import { DateFormats } from '../../constants/securspace-constants';
import { supplierInterchangesReportEndpoints} from '../../../requests/api-endpoints';
import { ActionInterchange } from '../data';

export interface RequestParams {
    locationId?: string,
    startDate?: string,
    endDate?: string,
    page?: string,
    size?: string,
    bookingNumber?: string,
    equipmentNumber?: string,
    assetType?: string,
    buyerId?: string,
    driverName?: string,
    activity?: string,
    sortBy?: string,
    sortDir?: 'asc' | 'desc',
    isPageable?: boolean
}

const getInterChangesUrlParams = (requestParams: RequestParams) => {

  const { page, size, locationId, startDate, endDate, bookingNumber, sortBy, buyerId, assetType, equipmentNumber, driverName, activity, sortDir, isPageable = false } = requestParams;

  const params = new URLSearchParams();

  if (isPageable) {
    params.append("page", page ? page : "0");
    params.append("size", size ? size : "10");
  }

  if (locationId) {
    params.append("locationId", locationId);
  }
  if (startDate) {
    params.append("startDate", moment(startDate).format(DateFormats.DAY));
  }
  if (endDate) {
    params.append("endDate", moment(endDate).format(DateFormats.DAY));
  }
  if (bookingNumber) {
    params.append("bookingNumber", bookingNumber)
  }
  if (buyerId) {
    params.append("buyerId", buyerId?.trim())
  }
  if (assetType && assetType !== 'All') {
    params.append("equipmentType", assetType)
  }
  if (equipmentNumber) {
    params.append("equipmentNumber", equipmentNumber)
  }
  if (driverName) {
    params.append("driverName", driverName.trim())
  }
  if (activity) {
    params.append("activity", activity)
  }
  if (sortBy && sortBy !== 'none') {
    params.append("sortBy", sortBy)
  }
  if (sortDir) {
    params.append("sortDir", sortDir)
  }

  return params;
}

export const getSupplierInterchanges = (searchParams: RequestParams, onSuccess?: () => void, onFail?: () => void ) => {

  const result = request.get(`${supplierInterchangesReportEndpoints.search}?${getInterChangesUrlParams(searchParams)}`);

  if (onSuccess && onFail) {
    result
      .then(onSuccess)
      .catch(onFail)
  } else {
    return result
  }
}

export const getSupplierInterchangesReport = (searchParams: RequestParams) => {
  return `${supplierInterchangesReportEndpoints.report}?${getInterChangesUrlParams(searchParams).toString()}`;
};

export const editInterchange = (interchange: ActionInterchange) => {
  return request.put(`${supplierInterchangesReportEndpoints.editActivity}`).send(interchange)
}

export const deleteInterchange = (id: string) => {
  return request.delete(`${supplierInterchangesReportEndpoints.deleteActivity(id)}`)
}

export const confirmBookingNumber = (orderNumber: string) => {
  return request.get(`${supplierInterchangesReportEndpoints.confirmBooking(orderNumber)}`)
}

export const moveInventory = (id: string, orderNumber: string) => {
  const body = { inventoryActivityId: id, orderNumber: orderNumber }
  return request.put(`${supplierInterchangesReportEndpoints.move}`).send(body)

}